import { API_BASE_URL } from '../../config/constants';
import { SupportLink } from '../../types/support.types';

const INTERCOM_FALLBACK: SupportLink[] = [
  {
    titleKey: 'Chat support',
    descriptionKey: 'Get help from our support team',
    type: 'intercom',
  },
  {
    titleKey: 'Email support',
    descriptionKey: 'Write to us at support@1browser.com',
    type: 'email',
    email: 'support@1browser.com',
  },
];

let cachedSupportLinks: SupportLink[] | null = null;

export const clearSupportLinksCache = (): void => {
  cachedSupportLinks = null;
};

export const getIntercomFallbackLinks = (): SupportLink[] => INTERCOM_FALLBACK;

export const fetchSupportLinks = async (): Promise<SupportLink[]> => {
  if (cachedSupportLinks) {
    return cachedSupportLinks;
  }

  const response = await fetch(`${API_BASE_URL}/v1/settings/support-links`);

  if (!response.ok) {
    throw new Error('Failed to fetch support links');
  }

  const data: SupportLink[] = await response.json();
  cachedSupportLinks = data;

  return data;
};
